import { useJsApiLoader } from '@react-google-maps/api';
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAP_ID } from '../config';

const libraries: ("places" | "geometry")[] = ["places", "geometry"];

/**
 * Custom hook to load Google Maps API with Dynamic Maps
 * Uses the same loader ID as MapViewLite to prevent conflicts
 * Includes "places" library for Autocomplete functionality in Fare Check
 */
export function useGoogleMaps() {
  const apiKey = GOOGLE_MAPS_API_KEY;
  const mapId = GOOGLE_MAP_ID;

  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script-mapviewlite', // Use same ID as existing MapViewLite component
    googleMapsApiKey: apiKey,
    libraries,
    mapIds: [mapId],
  });

  return {
    isLoaded,
    loadError,
  };
}

